<template>
  <div class="wrapper d-flex justify-content-end min-vh-100">
    <Sidebar />
    <div class="body">
      <CContainer fluid>
        <div class="inner-container">
          <router-view />
        </div>
      </CContainer>
    </div>
  </div>
</template>
<script>
import Sidebar from '@/components/SideBar.vue'

export default {
  components: {
    Sidebar,
  },
  setup() {
    return {}
  },
}
</script>
<style lang="scss" scoped>
.header {
  padding: 40px 0px;
}

.inner-container {
  margin: 0 auto;
  max-width: 1300px;
}
.body {
  width: calc(100vw - 255px);
}
</style>
